<template>
  <div id="data-list-list-view" class="store-act-wrap" v-if="isShow">
    <vs-tabs v-model="tabIndex" class="hd-tabs">
      <vs-tab
        :label="item.name"
        v-for="(item, index) in vsTabsList"
        :key="index"
        class="tabs"
      >
        <Configure v-if="tabIndex === 0" :pageSize="pageSize" @changePageSize="changePageSize" />
        <Entrance v-if="tabIndex === 1" :pageSize="pageSize" @changePageSize="changePageSize" />
        <Record v-if="tabIndex === 2"  :pageSize="pageSize" @changePageSize="changePageSize"/>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import Entrance from "./tabs/entrance/index";
import Configure from "./tabs/configure/index";
import Record from "./tabs/record/index";

export default {
  components: { Entrance, Configure, Record },
  data() {
    return {
      tabIndex: 0,
      isShow: false,
      vsTabsList: [
        {
          label: "error",
          name: "活动配置"
        },
        {
          label: "origin",
          name: "活动入口"
        },
        {
          label: "error",
          name: "活动记录"
        }
      ],
      pageSize: 20
    };
  },
  mounted () {
    console.log('tab',this.$route.query.tab);
    this.isShow = false
    setTimeout(() => {
      this.tabIndex = this.$route.query.tab || 0;
      this.isShow = true
    },0)
  },
  methods:{
    changePageSize(pageSize){
      this.pageSize = pageSize;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
#data-list-list-view{
  padding: 6px 12px;
}
.store-act-wrap{

}
.hd-tabs{
  border-bottom: 1px solid #DCDFE6;
  /deep/ .vs-tabs--content {
    padding: 10px 0;
  }
  /deep/ .vs-tabs--btn {
    padding: 8px 24px;
  }
  /deep/ .line-vs-tabs {
    width: 104px;
  }
}


.vs-tabs--li button.vs-tabs--btn {
  margin-top: 30px;
  
}
</style>
